<template>
  <div :class="$style['pt-page-search']">
      <label v-if="label" :class="$style['search-title']">{{label}}</label>
       <el-input :placeholder="placeholder" prefix-icon="el-icon-search"  :class="$style['pt-page-search-input']" v-model="search_key"
       @change="inputChange" :clearable="true" @keyup.enter.native="search"></el-input>
        <el-button type="primary" :class="$style['pt-page-search-button']" @click="search()">搜索</el-button>
  </div>
</template>

<script>
// 组件class前缀
import emitter from '@/mixins/emitter'

const prefixCls = 'pt-page-search'
export default {
  name: 'pt-page-search',
  mixins: [emitter],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    searchKey: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请填写关键字搜索'
    },
    // 搜索条件是否与其他筛选条件共存
    isParams: {
      type: Boolean,
      default: false
    },
    // 搜索关键字的字段名
    keyName: {
      type: String,
      default: 'searchKey'
    },
    isAddrouter: {
      type: Boolean,
      default: true
    },
    isQueryRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search_key: this.searchKey
    }
  },
  watch: {
    searchKey (val) {
      this.search_key = val
      if (!val) {
        this.notHaveSearchKey()
      }
    }
  },
  methods: {
    getAddRouter () {
      if (this.isQueryRouter) {
        let query = this.$route.query
        let data = {}
        data[this.keyName]=this.search_key
        this.$router.push({ name: this.$route.name, query: { page: query.page,...data } })
      }
    },
    // searchKey为null的时候，路由处理
    notHaveSearchKey () {
      let query = this.$route.query
      if (this.isAddrouter) {
        let newQuery = JSON.parse(JSON.stringify(query))
        this.$delete(newQuery, [this.keyName])
        this.$router.push({ name: this.$route.name })
        this.$router.push({ name: this.$route.name, query: newQuery })
      }
    },
    search () {
      // 搜索方法直接向调用pt-page-tiele组件的父组件发送事件
      this.dispatch('pt-page-title', 'search', this.search_key)
      this.getAddRouter()
      this.$emit('search', this.search_key)
    },
    inputChange () {
      if (!this.search_key) {
        this.dispatch('pt-page-title', 'emptySearch')
        this.$emit('emptySearch')
        this.notHaveSearchKey()
      } else {
        this.dispatch('pt-page-title', 'searchNo', this.search_key)
      }
    }
  },
  created () {
    let query = this.$route.query
    if (query.hasOwnProperty([this.keyName])) {
      this.search_key = query[this.keyName]
      this.search()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-page-search{
    display: flex,
}
.pt-page-search-input{
    flex: 1
}
.pt-page-search-button{
    margin-left: 20px;
}
.search-title{
    line-height: 40px
}
</style>
